import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision } from 'lib/optimizely/optimizelyUtils'
import { getChertoExperimentVariation } from 'selectors/experimentSelectors'

/**
 * Mirrors useExperiment's Cherto treatment decision for Cars surfaces that
 * cannot use a React hook, including navigation and SSR route matching.
 */
export function selectCarsAirportTransferIsVariant(state: App.State): boolean {
  const variationKey = getChertoExperimentVariation(state, ChertoExperiments.carsAirportTransfer)

  return getExperimentEnabledDecision(variationKey)
}
